// # Main landing page component
import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // # Import useNavigate
import { ShoppingOutlined } from "@ant-design/icons"; // # Import Ant Design icons
import Header from "./components/header"; // # Updated import
import Footer from "./components/footer"; // # Updated import
import "./landing.css"; // # Fixed CSS import
import "./landing_sections/landing_about_us.css"; // # Import new About section styles
import "./landing_sections/landing_our_lib.css"; // # Import library section styles
import "./landing_sections/landing_ment.css"; // # Import mentorship styles
import {
  FaBook,
  FaQuestion,
  FaClock,
  FaGraduationCap,
  FaBookOpen,
  FaBookMedical,
  FaUserMd,
  FaStethoscope,
  FaHospital,
  FaPlus,
  FaStar,
  FaBolt,
  FaMobileAlt,
  FaSave,
  FaSync,
  FaTablet,
  FaUsers,
  FaShoppingBag,
} from "react-icons/fa";
import "./landing_sections/landing_more.css"; // # Import new styles
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Landing() {
  // # Add navigation hook
  const navigate = useNavigate();

  // # Slick carousel settings
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // # Guide sections data
  const guideSections = [
    {
      title: "Anki Guide",
      icon: <FaGraduationCap className="lndg_qg_icon" />,
      description: "Master Anki for USMLE with our comprehensive guide",
      path: "/guide/anki",
      color: "#FF6B6B",
    },
    {
      title: "USMLE Libraries",
      icon: <FaBook className="lndg_qg_icon" />,
      description: "Navigate through our comprehensive USMLE libraries",
      path: "/guide/libraries",
      color: "#4ECDC4",
    },
    {
      title: "Question-Taking",
      icon: <FaQuestion className="lndg_qg_icon" />,
      description: "Learn effective strategies for answering USMLE questions",
      path: "/guide/questions",
      color: "#95A5A6",
    },
    {
      title: "Exam Day",
      icon: <FaClock className="lndg_qg_icon" />,
      description: "Prepare for your exam day with our comprehensive guide",
      path: "/guide/exam-day",
      color: "#A8E6CF",
    },
    {
      title: "Clinical Rotations",
      icon: <FaHospital className="lndg_qg_icon" />,
      description: "Essential tips and guidance for clinical rotations success",
      path: "/guide/rotations",
      color: "#9B59B6",
    },
  ];

  // # Add handler for Get Started button
  const handleGetStarted = () => {
    navigate("/signup");
  };

  // # Add state for resources section
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);

  // # Add toggle handler
  const toggleResources = () => {
    setIsResourcesOpen(!isResourcesOpen);
  };

  return (
    <div className="lndg_landing">
      <Header />

      <section
        className="lndg_hero-section"
        style={{
          background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('/icons/landing/hero.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <h1 className="lndg_animate-title">Welcome to TEMP-U</h1>
        <p className="lndg_hero-subtitle">
          The Only Study Resource You Will Ever Need To Crush The USMLE
        </p>
        <button className="lndg_cta-button" onClick={handleGetStarted}>
          Get Started
        </button>
      </section>

      {/* # Navigation Grid */}
      <div className="lndg_nav_grid">
        {/* # Main Navigation Buttons */}
        <button
          className="lndg_nav_btn products"
          onClick={() => navigate("/products")}
          aria-label="Our Products"
        >
          <FaShoppingBag className="lndg_nav_btn-icon" />
          <span>Our Products</span>
        </button>
        <button
          className="lndg_nav_btn team"
          onClick={() => navigate("/team")}
          aria-label="Meet Our Team"
        >
          <FaUsers className="lndg_nav_btn-icon" />
          <span>Meet Our Team</span>
        </button>
        <button
          className="lndg_nav_btn samples"
          onClick={() => navigate("/samples")}
          aria-label="Our Library Samples"
        >
          <FaBookMedical className="lndg_nav_btn-icon" />
          <span>Library Samples</span>
        </button>
        <button
          className="lndg_nav_btn about"
          onClick={() =>
            document
              .querySelector(".lndg_bts_about-section")
              .scrollIntoView({ behavior: "smooth" })
          }
          aria-label="About Us"
        >
          <FaUserMd className="lndg_nav_btn-icon" />
          <span>About Us</span>
        </button>
        <button
          className="lndg_nav_btn library"
          onClick={() =>
            document
              .querySelector(".lndg_libr_section")
              .scrollIntoView({ behavior: "smooth" })
          }
          aria-label="Our Library"
        >
          <FaBook className="lndg_nav_btn-icon" />
          <span>Our Library</span>
        </button>
        <button
          className="lndg_nav_btn mentorship"
          onClick={() =>
            document
              .querySelector(".lndg_mnt_section")
              .scrollIntoView({ behavior: "smooth" })
          }
          aria-label="Our Mentorship"
        >
          <FaGraduationCap className="lndg_nav_btn-icon" />
          <span>Our Mentorship</span>
        </button>
        <button
          className="lndg_nav_btn apps"
          onClick={() =>
            document
              .querySelector(".lndg_apps-section")
              .scrollIntoView({ behavior: "smooth" })
          }
          aria-label="Get Our Apps"
        >
          <FaMobileAlt className="lndg_nav_btn-icon" />
          <span>Get Our Apps</span>
        </button>
        <button
          className="lndg_nav_btn guides"
          onClick={() =>
            document
              .querySelector(".lndg_qg_section")
              .scrollIntoView({ behavior: "smooth" })
          }
          aria-label="USMLE Quick Guides"
        >
          <FaQuestion className="lndg_nav_btn-icon" />
          <span>Quick Guides</span>
        </button>
      </div>

      {/* # Reviews Section - Optimized */}
      <section className="lndg_reviews-section">
        <div className="lndg_section-content">
          <h2 className="lndg_section-title">Success Stories</h2>
          <p className="lndg_section-subtitle">
            We would be pleased to know you are willing to join our community of
            successful USMLE candidates
          </p>

          <div className="lndg_reviews-action">
            <p className="lndg_action-text">
              Read more success stories from our students
            </p>
            <button
              className="lndg_cta-button lndg_reviews-button"
              onClick={() => navigate("/reviews")}
            >
              To Reviews
            </button>
          </div>
        </div>
      </section>

      {/* # About Us Section */}
      <section className="lndg_bts_about-section">
        <div className="lndg_section-content">
          <h2 className="lndg_bts_section-title">About Us</h2>
          <p className="lndg_bts_section-subtitle">
            Your Trusted USMLE Partner
          </p>

          <div className="lndg_bts_about-container">
            <div className="lndg_bts_about-box">
              <h2 className="lndg_bts_about-heading">WHO WE ARE</h2>
              <p className="lndg_bts_about-text">
                We are a group of <strong>USMLE-passionate</strong> medical
                students & graduates driven by a shared mission to create the{" "}
                <strong>ultimate resource</strong> for mastering USMLE Step 1
                and Step 2. Having
                <strong>personally navigated</strong> the rigorous journey of
                these exams ourselves, we deeply understand the immense{" "}
                <strong>challenges and pressures</strong> faced by medical
                students.
              </p>
            </div>

            <div className="lndg_bts_about-box">
              <h2 className="lndg_bts_about-heading">OUR VISION</h2>
              <p className="lndg_bts_about-text">
                We are developing a <strong>revolutionary study system</strong>{" "}
                that simplifies complex medical concepts while maintaining the{" "}
                <strong>depth and precision</strong> necessary for success on
                the USMLE. Our content is crafted with a focus on{" "}
                <strong>clarity</strong>, <strong>accuracy</strong>, and{" "}
                <strong>relevance</strong>, ensuring that students not only{" "}
                <strong>excel in their exams</strong> but also build a{" "}
                <strong>strong foundation</strong>
                for their future medical practice.
              </p>
            </div>

            <div className="lndg_bts_about-box">
              <h2 className="lndg_bts_about-heading">OUR PROGRAM</h2>
              <p className="lndg_bts_about-text">
                Our <strong>Mentorship Program</strong> offers{" "}
                <strong>comprehensive support</strong> tailored to your needs.
                We provide a{" "}
                <strong>meticulously crafted study schedule</strong> guiding you
                from Day 1 until exam day, access to the{" "}
                <strong>best resources</strong> and a{" "}
                <strong>detailed roadmap</strong> for every topic ensuring
                high-yield learning, and
                <strong>expert guidance</strong> on effective note-taking
                techniques.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* # Library Section */}
      <section className="lndg_libr_section">
        <div className="lndg_section-content">
          <h2 className="lndg_libr_section-title">USMLE Library</h2>
          <p className="lndg_libr_section-subtitle">
            Your Ultimate Study Resource
          </p>

          <div
            className="lndg_libr_intro"
            style={{
              background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.2)), url('/icons/landing/study.jpg')`,
              backgroundSize: "100% auto",
              backgroundPosition: "center",
              backgroundColor: "#f5f5f5",
            }}
          >
            <div className="lndg_libr_intro-content">
              <p className="lndg_libr_intro-text">
                <span className="lndg_libr_intro-text-animate">
                  Our USMLE Library
                </span>{" "}
                is the{" "}
                <span className="lndg_libr_intro-text-shine">cornerstone</span>{" "}
                of our service, designed to be the{" "}
                <span className="lndg_libr_intro-text-glow">
                  most comprehensive
                </span>{" "}
                and{" "}
                <span className="lndg_libr_intro-text-glow">
                  efficient resource
                </span>{" "}
                for mastering{" "}
                <span className="lndg_libr_intro-text-highlight">Step 1</span>{" "}
                and{" "}
                <span className="lndg_libr_intro-text-highlight">Step 2</span>.
              </p>
            </div>
          </div>

          <div className="lndg_libr_features-grid">
            <div className="lndg_libr_feature-box">
              <h3>Curated for High-Yield Efficiency</h3>
              <p className="lndg_libr_feature-tagline">
                Not too much, not too little... <strong>SIMPLY PERFECT</strong>
              </p>
              <ul className="lndg_libr_feature-list">
                <li>
                  Focus on what <strong>TRULY matters</strong> for the USMLE
                </li>
                <li>
                  <strong>Distilled information</strong> into concise,
                  high-yield points
                </li>
                <li>
                  Efficient <strong>highlighting system</strong> for must-know
                  content
                </li>
              </ul>
            </div>

            <div className="lndg_libr_feature-box">
              <h3>Visual Learning Excellence</h3>
              <ul className="lndg_libr_feature-list">
                <li>
                  Vast collection of <strong>high-quality</strong>, detailed
                  images
                </li>
                <li>
                  Sourced from the <strong>most trusted materials</strong>
                </li>
                <li>
                  Enhanced <strong>"More pictures"</strong> feature for expanded
                  learning
                </li>
              </ul>
            </div>

            <div className="lndg_libr_feature-box">
              <h3>Complete Coverage</h3>
              <ul className="lndg_libr_feature-list">
                <li>
                  <strong>Comprehensive coverage</strong> of UWorld and Amboss
                  topics
                </li>
                <li>
                  Integrated <strong>UWorld tables</strong> for quick reference
                </li>
                <li>
                  Regular updates to match{" "}
                  <strong>evolving medical knowledge</strong>
                </li>
              </ul>
            </div>

            <div className="lndg_libr_feature-box">
              <h3>Smart Integration</h3>
              <ul className="lndg_libr_feature-list">
                <li>
                  <strong>Seamless incorporation</strong> with study schedules
                  for optimal learning flow
                </li>
                <li>
                  <strong>Intuitive navigation</strong> and{" "}
                  <strong>smart search</strong> functionality for quick access
                </li>
                <li>
                  <strong>Cross-platform accessibility</strong> - study
                  anywhere, anytime
                </li>
              </ul>
            </div>
          </div>

          <div className="lndg_libr_conclusion">
            <div className="lndg_libr_conclusion-quotes"></div>
            <p>
              With its <strong>unmatched combination</strong> of{" "}
              <strong>visual aids</strong> and{" "}
              <strong>high-yield content</strong>, our USMLE Library ensures{" "}
              <strong>efficient</strong> and <strong>less painful</strong> exam
              preparation.
            </p>
            <button
              className="lndg_libr_samples-button"
              onClick={() => navigate("/samples")}
            >
              View Library Samples
            </button>
          </div>
        </div>
      </section>

      {/* # Resources Subsection */}
      <section className="lndg_libr_resources">
        <div className="lndg_section-content">
          <div className="lndg_libr_resources-container">
            <div
              className={`lndg_libr_resources-header ${isResourcesOpen ? "active" : ""}`}
              onClick={toggleResources}
            >
              <div className="lndg_libr_resources-header-text">
                <h2 className="lndg_libr_resources-header-title">
                  Our References
                </h2>
                <p className="lndg_libr_resources-header-subtitle">
                  Click to view the comprehensive collection of resources used
                  to build our library
                </p>
              </div>
              <div className="lndg_libr_resources-toggle"></div>
            </div>

            <div
              className={`lndg_libr_resources-content ${isResourcesOpen ? "active" : ""}`}
            >
              <h2 className="lndg_libr_resources-intro">
                Built with care and patience, with our experience, our notes,
                thousands of hours of work, and the following resources
              </h2>

              <div className="lndg_libr_category-section">
                <h3 className="lndg_libr_category-title">
                  <FaBookMedical className="lndg_libr_category-icon" />
                  Question Banks & Exam Forms
                </h3>
                <ul className="lndg_libr_resources-list">
                  <li className="lndg_libr_resource-item">Amboss Library</li>
                  <li className="lndg_libr_resource-item">Amboss Qbank</li>
                  <li className="lndg_libr_resource-item">Uworld Qbank</li>
                  <li className="lndg_libr_resource-item">NBME Exam Forms</li>
                  <li className="lndg_libr_resource-item">CMS Exam Forms</li>
                </ul>
              </div>

              <div className="lndg_libr_category-section">
                <h3 className="lndg_libr_category-title">
                  <FaUserMd className="lndg_libr_category-icon" />
                  Student Notes
                </h3>
                <ul className="lndg_libr_resources-list">
                  <li className="lndg_libr_resource-item">Inner Circle</li>
                  <li className="lndg_libr_resource-item">Dirty Medicine</li>
                  <li className="lndg_libr_resource-item">
                    100 Cases Of Anatomy
                  </li>
                  <li className="lndg_libr_resource-item">
                    Mehlman Medical Notes
                  </li>
                  <li className="lndg_libr_resource-item">HY Gross Anatomy</li>
                </ul>
              </div>

              <div className="lndg_libr_category-section">
                <h3 className="lndg_libr_category-title">
                  <FaBookOpen className="lndg_libr_category-icon" />
                  First Aid Series
                </h3>
                <ul className="lndg_libr_resources-list">
                  <li className="lndg_libr_resource-item">
                    FA - For USMLE Step 1
                  </li>
                  <li className="lndg_libr_resource-item">
                    FA - For USMLE Step 1 - Clinical Pattern Recognition
                  </li>
                  <li className="lndg_libr_resource-item">
                    FA - For USMLE Step 2 - Clinical Algorithms
                  </li>
                  <li className="lndg_libr_resource-item">
                    FA - For USMLE Step 2 - Clinical Pattern Recognition
                  </li>
                  <li className="lndg_libr_resource-item">Rx Qbank</li>
                </ul>
              </div>

              <div className="lndg_libr_category-section">
                <h3 className="lndg_libr_category-title">
                  <FaStethoscope className="lndg_libr_category-icon" />
                  Atlases
                </h3>
                <ul className="lndg_libr_resources-list">
                  <li className="lndg_libr_resource-item">
                    Netter's Atlas Of Human Anatomy
                  </li>
                  <li className="lndg_libr_resource-item">
                    Netter Atlas Of Pathology
                  </li>
                  <li className="lndg_libr_resource-item">
                    Netter Atlas Of OBGYN
                  </li>
                  <li className="lndg_libr_resource-item">
                    Netter Atlas Of Clinical Medicine
                  </li>
                  <li className="lndg_libr_resource-item">
                    Netter Atlas Of Pediatrics
                  </li>
                  <li className="lndg_libr_resource-item">
                    Netter Atlas Of Surgery
                  </li>
                  <li className="lndg_libr_resource-item">
                    Grey's Atlas Of Anatomy
                  </li>
                </ul>
              </div>

              <div className="lndg_libr_category-section">
                <h3 className="lndg_libr_category-title">
                  <FaHospital className="lndg_libr_category-icon" />
                  Other Books And Series
                </h3>
                <ul className="lndg_libr_resources-list">
                  <li className="lndg_libr_resource-item">
                    The White Coat Companion For USMLE Step 2/3
                  </li>
                  <li className="lndg_libr_resource-item">
                    Boards & Beyond Video Lectures And Slides
                  </li>
                  <li className="lndg_libr_resource-item">
                    Pathoma Video Lectures And Book
                  </li>
                  <li className="lndg_libr_resource-item">Bootcamp</li>
                  <li className="lndg_libr_resource-item">
                    Divine Interventions Podcast
                  </li>
                  <li className="lndg_libr_resource-item">Anking Decks</li>
                  <li className="lndg_libr_resource-item">
                    Kaplan Biochemistry For Step 1
                  </li>
                  <li className="lndg_libr_resource-item">
                    Kaplan Neurology For Step 1
                  </li>
                  <li className="lndg_libr_resource-item">
                    Osmosis Video Lectures
                  </li>
                  <li className="lndg_libr_resource-item">
                    Physeo Video Lectures
                  </li>
                  <li className="lndg_libr_resource-item">
                    Pixorize Video Lectures
                  </li>
                  <li className="lndg_libr_resource-item">BRS - Physiology</li>
                  <li className="lndg_libr_resource-item">
                    USPSTF Recommendations
                  </li>
                  <li className="lndg_libr_resource-item">
                    Medquest Video Lectures
                  </li>
                  <li className="lndg_libr_resource-item">
                    Microbiology made ridiculously simple
                  </li>
                </ul>
              </div>

              <div className="lndg_libr_resources-footer">
                <div className="lndg_libr_resources-footer-content">
                  <FaStar className="lndg_libr_resources-footer-icon left" />
                  <p>
                    Among Many More Resources Being Used
                    <br />
                    <span className="lndg_libr_resources-footer-highlight">
                      To Offer The Best Study Materials For The Exam
                    </span>
                  </p>
                  <FaStar className="lndg_libr_resources-footer-icon right" />
                </div>
                <div className="lndg_libr_resources-footer-decoration">
                  <FaPlus className="lndg_libr_resources-footer-plus" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* # Mentorship Section */}
      <section className="lndg_mnt_section">
        <div className="lndg_section-content">
          <h2 className="lndg_mnt_section-title">Our Mentorship</h2>
          <p className="lndg_mnt_section-subtitle">
            Comprehensive Support for Your USMLE Journey
          </p>

          <div className="lndg_mnt_grid">
            <div className="lndg_mnt_box">
              <div className="lndg_mnt_box-content">
                <h3 className="lndg_mnt_feature-title">
                  <span className="lndg_mnt_feature-icon">▷</span>
                  Comprehensive Study Resources
                </h3>
                <ul className="lndg_mnt_feature-list">
                  <li>
                    Access to a complete <strong>USMLE Library</strong> for Step
                    1 and Step 2
                  </li>
                  <li>
                    A detailed <strong>study schedule</strong> guiding you from
                    Day 1 until exam day
                  </li>
                  <li>
                    <strong>Best resources and roadmap</strong> for every topic
                    to ensure high-yield learning
                  </li>
                  <li>
                    Guidance on utilizing <strong>ANKI flashcards</strong>{" "}
                    effectively
                  </li>
                  <li>
                    Support for <strong>efficient note-taking</strong>{" "}
                    techniques
                  </li>
                </ul>
              </div>
            </div>

            <div className="lndg_mnt_box">
              <div className="lndg_mnt_box-content">
                <h3 className="lndg_mnt_feature-title">
                  <span className="lndg_mnt_feature-icon">▷</span>
                  Personalized Support
                </h3>
                <ul className="lndg_mnt_feature-list">
                  <li>
                    <strong>Private tutoring</strong> tailored to your learning
                    style and weaknesses
                  </li>
                  <li>
                    <strong>24/7 Q&A support</strong> to clarify difficult
                    topics anytime (Although it is widely known that tutors{" "}
                    <strong>DO ACTUALLY SLEEP</strong> sometimes)
                  </li>
                  <li>
                    Regular <strong>meetings after each milestone</strong> to
                    recap progress
                  </li>
                  <li>
                    Our <strong>TEMP-U community</strong> to connect, share, and
                    motivate each other
                  </li>
                </ul>
              </div>
            </div>

            <div className="lndg_mnt_box">
              <div className="lndg_mnt_box-content">
                <h3 className="lndg_mnt_feature-title">
                  <span className="lndg_mnt_feature-icon">▷</span>
                  Skill-Building and Practice
                </h3>
                <ul className="lndg_mnt_feature-list">
                  <li>
                    <strong>Assignments after each chapter</strong> to reinforce
                    learning
                  </li>
                  <li>
                    Exclusive <strong>test-taking strategies</strong> to
                    maximize Q-bank performance
                  </li>
                  <li>
                    The <strong>wrong counter system</strong> to analyze
                    mistakes and strengthen weak areas
                  </li>
                </ul>
              </div>
            </div>

            <div className="lndg_mnt_box">
              <div className="lndg_mnt_box-content">
                <h3 className="lndg_mnt_feature-title">
                  <span className="lndg_mnt_feature-icon">▷</span>
                  Exam and Career Guidance
                </h3>
                <ul className="lndg_mnt_feature-list">
                  <li>
                    Assistance with opening your <strong>ECFMG account</strong>{" "}
                    and applying for the exams
                  </li>
                  <li>
                    Expert advice on the <strong>best time to apply</strong> for
                    the exam
                  </li>
                  <li>
                    Structured <strong>guidance through every stage</strong> of
                    your USMLE journey
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* # Get Our Apps Section */}
      <section className="lndg_apps-section">
        <div className="lndg_section-content">
          <h2 className="lndg_apps-title">Get Our Apps</h2>
          <p className="lndg_apps-subtitle">
            Access TEMP-U seamlessly on any device
          </p>

          <div className="lndg_apps-content">
            {/* Introduction Box */}
            <div className="lndg_apps-intro-box">
              <h3>Progressive Web Application (PWA)</h3>
              <p>
                TEMP-U is built as a Progressive Web Application (PWA), which
                means you can install it on your device, avoiding the
                unnecessary navigation through a web browser.
              </p>
            </div>

            {/* Features Box */}
            <div className="lndg_apps-features-box">
              <div className="lndg_apps-feature">
                <FaBolt className="lndg_apps-feature-icon" />
                <span>Faster loading times and better performance</span>
              </div>
              <div className="lndg_apps-feature">
                <FaMobileAlt className="lndg_apps-feature-icon" />
                <span>Native app-like experience on all devices</span>
              </div>
              <div className="lndg_apps-feature">
                <FaSync className="lndg_apps-feature-icon" />
                <span>Automatic updates without manual installation</span>
              </div>
            </div>

            {/* Browser Recommendation Box */}
            <div className="lndg_apps-browser-box">
              <div className="lndg_browser-content">
                <a
                  href="https://www.microsoft.com/edge"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lndg_edge-link"
                >
                  <img
                    src="/icons/landing/edge.png"
                    alt="Microsoft Edge"
                    className="lndg_edge-icon"
                  />
                </a>
                <div className="lndg_browser-text">
                  <p className="lndg_browser-main">
                    We recommend Microsoft Edge web browser for optimal
                    performance
                  </p>
                  <p className="lndg_browser-sub">
                    Experience faster loading times and better PWA support
                  </p>
                </div>
              </div>
            </div>

            {/* Installation Instructions Grid */}
            <div className="lndg_apps-instructions-grid">
              {/* Row 1 */}
              <div className="lndg_apps-platform windows">
                <h3>
                  <img
                    src="/icons/landing/windows.png"
                    alt="Windows"
                    className="lndg_platform-icon"
                  />
                  Windows
                </h3>
                <ol className="lndg_platform-steps">
                  <li>Open Microsoft Edge browser</li>
                  <li>Navigate to TEMP-U website</li>
                  <li>
                    Click the <strong>⋮</strong> menu in the top-right corner
                  </li>
                  <li>Select "Apps" → "Install TEMP-U"</li>
                </ol>
                <div className="lndg_platform-note">
                  Recommended for the best desktop experience
                </div>
              </div>

              <div className="lndg_apps-platform android">
                <h3>
                  <img
                    src="/icons/landing/android.png"
                    alt="Android"
                    className="lndg_platform-icon"
                  />
                  Android Smartphone
                </h3>
                <ol className="lndg_platform-steps">
                  <li>Visit TEMP-U in Microsoft Edge browser</li>
                  <li>Wait for the "Add to Home Screen" prompt</li>
                  <li>
                    If no prompt appears, click the <strong>⋮</strong> menu
                  </li>
                  <li>Select "Apps" → "Install TEMP-U"</li>
                </ol>
                <div className="lndg_platform-note">
                  Perfect for on-the-go studying
                </div>
              </div>

              <div className="lndg_apps-platform android-tablet">
                <h3>
                  <img
                    src="/icons/landing/android.png"
                    alt="Android Tablet"
                    className="lndg_platform-icon"
                  />
                  Android Tablet
                </h3>
                <ol className="lndg_platform-steps">
                  <li>Open Microsoft Edge browser</li>
                  <li>Visit TEMP-U website</li>
                  <li>
                    Tap the <strong>⋮</strong> menu
                  </li>
                  <li>Select "Apps" → "Install TEMP-U"</li>
                </ol>
                <div className="lndg_platform-note">
                  Optimized for larger screens
                </div>
              </div>

              {/* Row 2 */}
              <div className="lndg_apps-platform ios">
                <h3>
                  <img
                    src="/icons/landing/apple.png"
                    alt="iOS"
                    className="lndg_platform-icon"
                  />
                  iPhone
                </h3>
                <ol className="lndg_platform-steps">
                  <li>Open Microsoft Edge browser</li>
                  <li>Visit TEMP-U website</li>
                  <li>
                    Tap the <strong>⋮</strong> menu
                  </li>
                  <li>Select "Apps" → "Install TEMP-U"</li>
                </ol>
                <div className="lndg_platform-note">
                  Perfect for on-the-go studying
                </div>
              </div>

              <div className="lndg_apps-platform ipad">
                <h3>
                  <FaTablet className="lndg_platform-icon" />
                  iPad
                </h3>
                <ol className="lndg_platform-steps">
                  <li>Open Microsoft Edge browser</li>
                  <li>Visit TEMP-U website</li>
                  <li>
                    Tap the <strong>⋮</strong> menu
                  </li>
                  <li>Select "Apps" → "Install TEMP-U"</li>
                </ol>
                <div className="lndg_platform-note">
                  Optimized for larger screens
                </div>
              </div>

              <div className="lndg_apps-platform macos">
                <h3>
                  <img
                    src="/icons/landing/apple.png"
                    alt="MacOS"
                    className="lndg_platform-icon"
                  />
                  MacOS
                </h3>
                <ol className="lndg_platform-steps">
                  <li>Open Microsoft Edge browser</li>
                  <li>Visit TEMP-U website</li>
                  <li>
                    Click the <strong>⋮</strong> menu
                  </li>
                  <li>Select "Apps" → "Install TEMP-U"</li>
                </ol>
                <div className="lndg_platform-note">
                  Native-like performance on Mac
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* # USMLE Quick Guide Section */}
      <section className="lndg_qg_section">
        <div className="lndg_section-content">
          <h2 className="lndg_qg_section-title">USMLE Quick Guides</h2>
          <p className="lndg_qg_section-subtitle">
            Essential resources to enhance your USMLE preparation
          </p>

          <div className="lndg_qg_carousel-container">
            <Slider {...carouselSettings} className="lndg_qg_carousel">
              {guideSections.map((section, index) => (
                <div key={index}>
                  <div
                    className="lndg_qg_card"
                    onClick={() => navigate(section.path)}
                    style={{ "--icon-color": section.color }}
                  >
                    <div className="lndg_qg_icon-container">
                      <div className="lndg_qg_icon-inner">{section.icon}</div>
                      <div className="lndg_qg_icon-ring"></div>
                    </div>
                    <h3 className="lndg_qg_title">{section.title}</h3>
                    <p className="lndg_qg_description">{section.description}</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Landing;
